import { useTranslation } from 'react-i18next'

/**
 * NormalHeader is a function component that displays a header with
 * instructions based on the current step of the process.
 *
 * @param {Object} props - The component's props.
 * @param {number} props.step - The current step of the process.
 *
 * @returns {JSX.Element} A div element containing the header.
 */
function NormalHeader({ step }: { step: number }) {
  const { t } = useTranslation()
  return (
    <div className='w-full'>
      <h2 className='text-center text-lg font-normal font-poppins'>
        {step === 1 && t('Enter Makyo')}
        {step === 2 && t('Check your email for a code')}
        {step === 3 && t('Enter 2FA Code')}
      </h2>
    </div>
  )
}

export default NormalHeader
